import * as Yup from 'yup';

import { Language } from '@pdcplan/shared/generated/language/TeamPlan';

export const loginValidationSchema = (lang: Language) => {
  return Yup.object().shape({
    username: Yup.string()
      .required(lang.UserNameIsRequired)
      .test({
        test: (value) =>
          value && !value.startsWith(' ') && !value.endsWith(' '),
        message: lang.LoginPasswordNoBlackSpacesAtStartOrEnd,
      }),
    password: Yup.string().required(lang.passwordIsRequired),
  });
};
